/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DisableTenantDestinationRequest = {
  /**
   * The ID of the tenant. Required when using AdminApiKey authentication.
   */
  tenantId: string;
  /**
   * The ID of the destination.
   */
  destinationId: string;
};

/** @internal */
export const DisableTenantDestinationRequest$inboundSchema: z.ZodType<
  DisableTenantDestinationRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  tenant_id: z.string(),
  destination_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "tenant_id": "tenantId",
    "destination_id": "destinationId",
  });
});
/** @internal */
export type DisableTenantDestinationRequest$Outbound = {
  tenant_id: string;
  destination_id: string;
};

/** @internal */
export const DisableTenantDestinationRequest$outboundSchema: z.ZodType<
  DisableTenantDestinationRequest$Outbound,
  z.ZodTypeDef,
  DisableTenantDestinationRequest
> = z.object({
  tenantId: z.string(),
  destinationId: z.string(),
}).transform((v) => {
  return remap$(v, {
    tenantId: "tenant_id",
    destinationId: "destination_id",
  });
});

export function disableTenantDestinationRequestToJSON(
  disableTenantDestinationRequest: DisableTenantDestinationRequest,
): string {
  return JSON.stringify(
    DisableTenantDestinationRequest$outboundSchema.parse(
      disableTenantDestinationRequest,
    ),
  );
}
export function disableTenantDestinationRequestFromJSON(
  jsonString: string,
): SafeParseResult<DisableTenantDestinationRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DisableTenantDestinationRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DisableTenantDestinationRequest' from JSON`,
  );
}
